import { render, staticRenderFns } from "./GoodsRemarkPage.vue?vue&type=template&id=89a47434&scoped=true&"
import script from "./GoodsRemarkPage.vue?vue&type=script&lang=js&"
export * from "./GoodsRemarkPage.vue?vue&type=script&lang=js&"
import style0 from "./GoodsRemarkPage.vue?vue&type=style&index=0&id=89a47434&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a47434",
  null
  
)

export default component.exports